"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crypt = void 0;
var AppCrypt_1 = require("./core/crypt/AppCrypt");
var crypt = require('./core/crypt/libs/aesCrypt');
var Crypt = /** @class */ (function () {
    function Crypt() {
    }
    Crypt.generateSeed = AppCrypt_1.AppCrypt.generateSeed;
    Crypt.generateAccountSeed = AppCrypt_1.AppCrypt.generateAccountSeed;
    Crypt.getKeyPairFromSeed = AppCrypt_1.AppCrypt.getKeyPairFromSeed;
    Crypt.generateKeys = AppCrypt_1.AppCrypt.generateKeys;
    Crypt.addressByPublicKey = AppCrypt_1.AppCrypt.getAccountAddressFromPublicKey;
    Crypt.addressBySecretKey = AppCrypt_1.AppCrypt.getAddressBySecretKey;
    Crypt.publicKeyBySecretKey = AppCrypt_1.AppCrypt.getPublicKeyBySecretKey;
    Crypt.sign = AppCrypt_1.AppCrypt.sign;
    Crypt.sha256 = AppCrypt_1.AppCrypt.sha256big;
    Crypt.decryptMessage = crypt.decryptMessage;
    Crypt.decryptMessage64 = crypt.decryptMessage64;
    Crypt.encryptMessage = crypt.encryptMessage;
    Crypt.decryptAES = crypt.decryptAES;
    Crypt.decryptAES64 = crypt.decryptAES64;
    Crypt.encryptAES = crypt.encryptAES;
    Crypt.encryptBytes = crypt.encryptBytes;
    Crypt.passwordAES = crypt.passwordAES;
    Crypt.wordsToBase58 = crypt.wordsToBase58;
    Crypt.wordsToUtf8 = crypt.wordsToUtf8;
    Crypt.wordsToBytes = crypt.wordsToBytes;
    Crypt.bytesToWords = crypt.bytesToWords;
    return Crypt;
}());
exports.Crypt = Crypt;
